import React, { Component} from 'react';
import './Research.css';
import { IconContext } from "react-icons";
import { BiChevronLeft, BiSidebar } from "react-icons/bi";


class Research extends Component {
  constructor(props) {
    super(props);

    this.state = {
      
    };
  }

  componentDidUpdate(){
    
  }
 
  componentDidMount(){
  }

  render() {
    return (
      <div className = "researchPage fadeResearchAnimation researchscrollableSec">
        <div className = "researchHeader">
          </div>
        
        <div className = "researchSection">
          
          <h3>Research Areas</h3>
          <p> At the X-Lab, we work on a wide range of different research areas. We present some of the selected topics below: </p>
          <div className = "researchIcon3">
            <div className = "researchPic" style = {{"backgroundImage" : "url('pics/signal.png')"}}>
            </div>
            <div className = "researchBio">
              <p class="researchName">Signal Processing and Machine Learning</p>
              <p class="researchTitle">Using state of the art machine learning and signal processing techniques to understand and identify patterns in natural signals.</p>

            </div>
          </div>

          <div className = "researchIcon3">
            <div className = "researchPic" style = {{"backgroundImage" : "url('pics/sensors.jpg')"}}>
            </div>
            <div className = "researchBio">
              <p class="researchName">Interactive Sensors and Wearable Technologies</p>
              <p class="researchTitle">Combining computer science with electrical and hardware engineering to develop novel sensors and wearables. </p>

            </div>
          </div>

          <div className = "researchIcon3">
            <div className = "researchPic" style = {{"backgroundImage" : "url('pics/vr.jpeg')"}}>
            </div>
            <div className = "researchBio">
              <p class="researchName">AR/VR Interactions</p>
              <p class="researchTitle">Using virtual reality and augmented reality technologies to develop novel collaborative interactions. </p>

            </div>
          </div>

          <div className = "researchIcon3">
            <div className = "researchPic" style = {{"backgroundImage" : "url('pics/cv.jpeg')"}}>
            </div>
            <div className = "researchBio">
              <p class="researchName">Applied Computer Graphics and Vision</p>
              <p class="researchTitle">Applying and extending upon computer graphics and vision techniques to find new ways to explore and view the world.</p>

            </div>
          </div>

          <div className = "researchIcon3">
            <div className = "researchPic" style = {{"backgroundImage" : "url('pics/virtual.webp')"}}>
            </div>
            <div className = "researchBio">
              <p class="researchName">Virtual Entertainment</p>
              <p class="researchTitle">Understanding new forms of entertainment and developing tools to support and empower creators and audiences.</p>

            </div>
          </div>

          <div className = "researchIcon3">
            <div className = "researchPic" style = {{"backgroundImage" : "url('pics/design.webp')"}}>
            </div>
            <div className = "researchBio">
              <p class="researchName">Novel Interface Design</p>
              <p class="researchTitle">Designing meaningful and user-friendly ways for interaction, supporting ubiquitous computing in all aspects. </p>

            </div>
          </div>
          <div className = "researchFooter">
        </div>
        
        </div>
      </div>
    )
  }
}

export default Research;
